import { createEffect, onCleanup, Show } from "solid-js"
import { createStore } from "solid-js/store"
import { useLanguage } from "@/context/language"
import { reportPreviewPath } from "@/datox/report-preview"

export function DatoxReportPreviewLink(props: { projectID: string; artifactID: string; copyOnly?: boolean }) {
  const language = useLanguage()
  const [store, setStore] = createStore({ copied: false, failed: false })
  const path = () => reportPreviewPath(props.projectID, props.artifactID)
  createEffect(() => { path(); setStore({ copied: false, failed: false }) })
  createEffect(() => {
    if (!store.copied) return
    const timer = setTimeout(() => setStore("copied", false), 2000)
    onCleanup(() => clearTimeout(timer))
  })
  const copy = async () => {
    const link = new URL(path(), window.location.origin).href
    try {
      await navigator.clipboard.writeText(link)
      setStore({ copied: true, failed: false })
    } catch {
      setStore({ copied: false, failed: true })
    }
  }
  return <div class="flex flex-wrap items-center gap-2 text-12-medium">
    <Show when={!props.copyOnly}><a href={path()} target="_blank" rel="noopener noreferrer" class="rounded-lg border border-v2-border-border-base px-3 py-2 hover:bg-v2-background-bg-layer-02">{language.t("datox.pipeline.report.openPreview")} ↗</a></Show>
    <button type="button" class="grid place-items-center rounded-lg border border-v2-border-border-base px-3 py-2 hover:bg-v2-background-bg-layer-02" aria-label={language.t(store.copied ? "datox.pipeline.report.linkCopied" : "datox.pipeline.report.copyPreviewLink")} onClick={() => void copy()}>
      <span class="col-start-1 row-start-1" classList={{ invisible: store.copied }} aria-hidden="true">{language.t("datox.pipeline.report.copyPreviewLink")}</span>
      <Show when={store.copied}><svg class="col-start-1 row-start-1" aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m5 12 4 4L19 6" /></svg></Show>
    </button>
    <span role="status" class="sr-only"><Show when={store.copied}>{language.t("datox.pipeline.report.linkCopied")}</Show></span>
    <Show when={store.failed}><span role="alert">{language.t("datox.pipeline.report.copyFailed")}</span></Show>
  </div>
}
